import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IPatient } from '../../models/patient.interface';
import { PatientService } from '../../services/patient.service';
@Component({
  selector: 'app-list-pacientes',
  templateUrl: './list-pacientes.component.html',
  styleUrls: ['./list-pacientes.component.scss']
})
export class ListPacientesComponent {
  @Input() pacientes: IPatient[] = [];
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();

  constructor(
    private readonly router: Router,
    private readonly patientService: PatientService
  ) {}

  visualizarProntuario(paciente: IPatient): void {
    this.patientService.setSelectedPatient(paciente);
    this.router.navigate(['/dash/pacientes/prontuario', paciente.id]);
  }
}
